import React from "react";

export default function Statistics_Variability() {
  return (
    <div>
      <h1>Statistics_Variability</h1>
      <p>This is the Statistics_Variability component.</p>
    </div>
  );
}
